import { gql } from '@apollo/client';

export const CUSTOMER_RESOURCE_FRAGMENT = gql`
  fragment CustomerResourceFragment on CustomerResource {
    resourceId
  }
`;
